export const timeout = {
  min: 1 * 1000, // 1 second
  max: 1 * 60 * 1000, // 1 minute
};

// parts of a message that are required to show
const requiredMessage = {
  type: 'danger',
  text: 'Oops! something went wrong',
};

// default values to use on empty/string inputs
const defaultMessage = {
  timeout: 10 * 1000, // 10 seconds
  icon: 'icon-attention-circle',
  dismissible: true,
};

const buildMessage = input => {
  const output = { ...requiredMessage };
  if (!input || typeof input === 'string') {
    Object.assign(output, defaultMessage);
    if (input) {
      output.text = input;
    }
  } else {
    Object.assign(output, input);
  }

  if (output.timeout) {
    if (output.timeout > timeout.max) {
      output.timeout = timeout.max;
    }
    if (output.timeout < timeout.min) {
      output.timeout = timeout.min;
    }
  }

  if (!output.id) {
    output.id = `${output.title || output.text}.${output.type}`;
  }
  return output;
};

export default buildMessage;
